module.exports = __webpack_public_path__ + "static/beyondxscratch-aa0047c3fdce40de73462c2cf9a557e4.png";